<div>
  <div class="row" *ngFor="let control of formArray.controls; let i = index">
    <div class="col pb-4">
      <app-permit-access-control
        *ngIf="receivers"
        [receivers]="receivers"
        [formControl]="control">
        <mat-error *ngIf="control.touched && control.errors">
          <span *ngIf="control.errors.isDuplicatedItem">{{'ErrorMessages.DuplicatedControl' | translate:({controlNames: ('Receivers.PermitAccess' | translate)})}}</span>
          <span *ngIf="!control.errors.isDuplicatedItem">{{'ErrorMessages.Required' | translate}}</span>
        </mat-error>      </app-permit-access-control>
    </div>

    <div class="col-auto pt-6" *ngIf="formArray.controls?.length > 1">
      <button type="button" color="warn" mat-icon-button (click)="removeControl(i)"><mat-icon>delete</mat-icon></button>
    </div>
  </div>

  <div class="mb-6" style="margin-top: -0.75rem">
    <button type="button" mat-flat-button class="p-0" (click)="addAnotherControl()">
      <span class="flex align-center text-primary">
        <mat-icon>add_circle_outline</mat-icon>
        <span class="text-underline text-bold">{{'Buttons.AddAnotherPermitAccess' | translate}}</span>
      </span>
    </button>
  </div>
</div>
